import {React, useEffect, useState, useContext} from 'react'
import PriceAgricultureParityFormforBullData from '../../../../Components/PriceAgricultureParityFormforBullData'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import {shortMonthToFull,handleUserLevelAccessPermissions,getAllYears,validateRolesBull,validateMonthYears,shortMonthToMonthNumber,getNextYear,isNumeric} from '../../../../Custom/Custom'
import messages from '../.././../../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';

function PriceAgricultureParityFormforBull() {

    const [districtList, setDistrictList] = useState([]);
    const [blockList, setBlockList] = useState([]);
    const [blockCode, setBlockCode] = useState('')
    const [years, setYears] = useState([]);
    const [months, setMonth] = useState([]);
    const [districtCode, setDistrictCode] = useState('');
    const [yearName, setYearName] = useState('');
    const [monthName, setMonthName] = useState('');
    const [priceAgrilcultureData, setPriceAgrilcultureData] = useState([]);
    const [payload, setPayload] = useState([]);
    const [isDivision, setIsDivision ] = useState(false);
    const [desiBull, setDesiBull ] = useState('');
    const [greadedBull , setGreadedBull  ] = useState('');
    const [checkdatais , setcheckdatais  ] = useState('');
    const [buttonAccess, setButtonAccess] =  useState({userLevel:'',roles:'',isVisible:false});
    const token = useContext(MyContextProvider).token;
    const decode_token =jwtDecode(token)
    const navigate = useNavigate();
    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }



      useEffect(() => {
        
        const level =  handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level)
  
        // get District By Division ID
        const getDistrictListByDivision = async () => {
          try {
            const response =  await axios.post(
              `${API_URL}api/geDistrictListByDivisionId`,
              { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config );
            const allDistrict = response.data;
           
           if (allDistrict.status) {
                setDistrictList(allDistrict.data);
                showLoading(false);
            }
            } catch (error) {
            console.error(error);
            showLoading(false);
            }
          }
  
  
  
         // All district list
          const getDistrictList = async () => {
          
              try {
                  const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
                  const allDistrict = response.data;
          
                  if (allDistrict.status) {
                      setDistrictList(allDistrict.data);
                      showLoading(false);
                  }
              } catch (error) {
              console.error(error);
              showLoading(false);
              }
          };
  
        //Get all Months data    
       const getMonthsList = (e) => { 
          showLoading(true)
              axios
                .get(`${API_URL}api/graph/getMonths/2019`, config)
                .then((res) => {
                  let monthDataResponse = res.data;
                  if (monthDataResponse.status) {
                    setMonth(monthDataResponse.data);
                    showLoading(false)
                  }
                })
                .catch((err) => {
                  console.error(err);
                 showLoading(false);
                });
            }
  
  
        const getYearList =()=>{
              setYears(getAllYears());
            }
  
       
   const userRole = async () => {
          showLoading(true)
          try {
            const role = await validateRolesBull(decode_token)
            if (role) {
                  getYearList();
                  getMonthsList();
        
                  if(level.userLevel==='DIVISION LEVEL' && level.roles.includes('DIVADM')){
                    getDistrictListByDivision()
                    setIsDivision(true)
                  }else{
                      getDistrictList()
                }
  
           }else {
          
              alert("You are not an authorized user to capture the data for Pricing");
              navigate("/dashboard");
            }
          } catch (error) {
            console.log(error);
            showLoading(false)
          }
        }
    
    
        userRole();
  
         
      },[]);

  const handleDropdownChange=(e)=>{
    
    switch(e.target.name){
      case 'district_name':
            setDistrictCode(e.target.value)
            handleDistrictOnChange(e.target.value)
            setMonthName('')
            setYearName('')
            
      break;
      case 'block_name':
        setBlockCode(e.target.value)
    
      break;
      case 'month_name':
            setMonthName(e.target.value)
            setYearName('')
      break;
      case 'year_name':

          if(!validateMonthYears(e.target.value,monthName)){
            setMonthName('')
            setYearName('')
            return;
          }
      
          if(districtCode===''){
            toast.error(messages.DISTRICT_MSG, messages.COLOR_RED);
            setYearName('')
            return;
          }
      
        if(monthName===''){
          toast.error(messages.MONTH_MSG, messages.COLOR_RED);
          setYearName('')
            return;
        }
          setYearName(e.target.value)
          let postData={
            "district_code": districtCode,
            "month_ws": monthName,
            "year_ws": e.target.value
          }
          
          onChangePriceAgricultureParityFormforBullData(postData)

              
      break;
      default:
        console.log("switch case are not match");
    break;

    }
  }
       

  const handleDistrictOnChange=async(DistId)=>{
    showLoading(true);
    const postData={district_code: DistId}
    try {
      // Make API call to fetch data
      const response = await axios.post(`${API_URL}api/otherPrices/PriceAgricultureParityBullForm`, postData, config);
    
      if (response.data.status) {
        setPriceAgrilcultureData(response.data.data.GroupCodes);
        setPayload(response.data.data.payload);
        showLoading(false);
      }
    } catch (error) {
      console.error('Error posting data:', error);
      showLoading(false);
    }
  }


const onChangePriceAgricultureParityFormforBullData=async(postData)=>{
  showLoading(true);

  try {
    
    const response = await axios.post(`${API_URL}api/otherPrices/PriceAgricultureParityBullWithData`, postData, config);
    if (response.data.status) {
      setPriceAgrilcultureData(response.data.data.GroupCodes);
      setcheckdatais(response.data.data.GroupCodes.length);
      setPayload(response.data.data.payload);
      showLoading(false);
    }
  } catch (error) {
    console.error('Error posting data:', error);
    showLoading(false);
  }

}

const resetMothAndYearField = () => {
  setMonthName('')
  setYearName('')
  setDistrictCode('')
  setPriceAgrilcultureData([]);
}
 

 const storedLanguage = localStorage.getItem('language');

 const handleSubmitForm=()=>{
     if(districtCode===''){
      toast.error("Please Select District", messages.COLOR_RED);
      return false;
     }

     if (monthName === '') {
      toast.error(messages.MONTH_NAME_MSG, messages.COLOR_RED);
      return false;
     } 
      if(yearName === '') {
          toast.error(messages.YEAR_NAME_MSG, messages.COLOR_RED);
          return false;
      }

      if(checkdatais === 0){
        toast.error("Please select another district as no items are present.", messages.COLOR_RED);
        return false;
      }

   return true;
 }

 //Handle Reset Form
 const handleResetForm=()=>{
  resetMothAndYearField();
  setDesiBull('')
  setGreadedBull('')
 }
 
 //Handle on Change Event 
 const handleOnChange=(e)=>{
   if(!isNumeric(e.target.value)){
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
    return false;
    }
    if(e.target.name==='desiBullPrice'){
      setDesiBull(e.target.value)
    }

    if(e.target.name==='gradedBullPrice'){
      setGreadedBull(e.target.value)
    }

 }

  return (
    <>
   
    <ToastContainer/>
    <GlobalLoading />
      <div className="container-fluid py-3">
       <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
         <div className="row align-items-center">
             <h4 className="page_heading">
             <span className="text_orange">Price Statistics Uttar Pradesh </span> {storedLanguage === 'hi' ? titlesData.hi.PriceAgricultureParityFormforBull : titlesData.en.PriceAgricultureParityFormforBull} (Base Year: 2011-12)
             </h4>
           
             <div className="row align-items-center">
             {isDivision &&
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                     <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
             }
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                     <select
                      name="district_name"
                      id="district_name"
                      className="form-select"
                     onChange={handleDropdownChange}
                     value={districtCode}
                    >
                   <option value="" disabled>Select District</option>
                   {districtList &&
                     districtList
                       .slice()
                       .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                       .map((ele, index) => (
                         <option key={index} value={ele.DISTRICT_CODE}>
                           {ele.DISTRICT_NAME}
                         </option>
                       ))}
                 </select>
                 </div>
                 {/* <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.BLOCK_NAME : titlesData.en.BLOCK_NAME}</label>
                     <select
                      name="block_name"
                      id="block_name"
                      className="form-select"
                     onChange={handleDropdownChange}
                     value={blockCode}
                    >
                   <option value="" disabled>Select Block</option>
                   {blockList &&
                     blockList.map((ele, index) => (
                         <option key={index} value={ele.BLOCK_CODE}>
                           {ele.BLOCK_NAME}
                         </option>
                       ))}
                 </select>
                 </div> */}
 
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                 <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                  <select  name="month_name"
                   className="form-select"  
                   onChange={handleDropdownChange} 
                   value={monthName}
                   >
                     <option value="" disabled>Select Month</option>
                       {months && months.map((ele, i) => (
                         <option key={i} value={shortMonthToMonthNumber(ele.MONTH)}>
                         {shortMonthToFull(ele.MONTH)}
                         </option>
                       ))}
                 </select>
                 </div>
 
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                 <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
                     <select  name="year_name" 
                      className="form-select" 
                      onChange={handleDropdownChange}  
                       value={yearName} >
                         <option value="" disabled>Select Year</option>
                         {years && years.map((ele, index) => (
                           <option key={index} value={ele}>
                           {getNextYear(ele)}
                           </option>
                         )) }
                   </select>
                 </div>
             </div>
         </div>
       </div>
     </div>
 
     <div className="card mx-3 mb-3">
         

         {
        priceAgrilcultureData.length > 0 ? (
          <PriceAgricultureParityFormforBullData 
          type="PriceBullData" 
          payload={payload} 
          districtCode={districtCode} 
          config={config} 
          resetMothAndYearField={resetMothAndYearField}  
          userInfoObject={buttonAccess}  
          yearName={yearName} 
          monthName={monthName} 
          blockCode={blockCode} 
          priceAgrilcultureData={priceAgrilcultureData}
          />
        ) : (
            <div className="card-body">
            <div className="table-responsive">
            <table className="table table-bordered">
            <thead>
              <tr>
                <th>Serial No.</th>
                <th>Market Name</th>
                <th>Desi Bull Price</th>
                <th>Greaded bull Price</th>
                <th>Remarks</th>
              
              </tr>
            </thead>
            <tbody>
              
            <tr>
              <td>1</td>
            <td>
              <input 
              type="text" 
              className="form-control" 
              name="marketName_1" 
              id="marketName_1" 
              readOnly
               />
            </td>

              <td>
                <input 
                type="text" 
                className="form-control" 
                name="desiBullPrice" 
                id="desiBullPrice" 
                value={desiBull}
                onChange={(e)=>handleOnChange(e)}
                maxLength='12'
                />
               </td>

              <td>
                <input 
                type="text" 
                className="form-control" 
                name="gradedBullPrice" 
                id="gradedBullPrice" 
                value={greadedBull}
                onChange={(e)=>handleOnChange(e)}
                maxLength='12'
                 />
              </td>
              <td>
                <select 
                className="form-select" 
                name="remark_1" 
                id="remark1"
                >
                <option value="">[---Select---]</option>
                <option value="Price is Too Low">Price is Too Low</option>
                <option value="Price is too High">Price is too High</option>
                <option value="Price does not match with unit">Price does not match with unit</option>
                <option value="Price does not match with variety">Price does not match with variety</option>
                <option value="Other">Other</option></select>
                </td>
            </tr>
          </tbody>    

               </table>
              </div>

            <div className="row">
                <div className="col-12 text-center pt-3">
              
                <button
                  onClick={(e) => handleSubmitForm(e, 'SAVE')}
                  type="button"
                  className="btn btn_orange mx-1"
                  >Save
                </button>
              
                <button
                  onClick={(e) => handleSubmitForm(e, 'ACCEPT')}
                  type="submit"
                  className="btn btn_orange mx-1"
                  >Submit
                </button>
            


                <button 
                  type="reset" 
                  className="btn btn_orange mx-1" 
                  onClick={handleResetForm} 
                  >
                  Reset
                </button>
                <button 
                  type="button" 
                  className="btn btn_orange mx-1" 
                  onClick={(e)=>( navigate("/dashboard"))}
                  >
                  Cancel
                </button>
            </div>
            </div>
            
         </div>



        
               
         )
         }
    </div>




     </div>
    
     </>
  )
}

export default PriceAgricultureParityFormforBull